export default __webpack_public_path__ + "static/media/gc_logo_square_white.1c53067a.svg";